define("settings/components/plan-recommendation/plan-card", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@ember/template", "@glimmer/component", "ember-concurrency", "settings/utils/plan-card", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _template, _component2, _emberConcurrency, _planCard, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@ember/template",0,"@glimmer/component",0,"ember-concurrency",0,"settings/utils/plan-card",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="cPR--planCard"
    data-test-id="plan-recommendation-plan-card"
    data-test-tier={{@recommendation.tier}}
    ...attributes
  >
    <h1 class="cPR--planCard__headline" data-test-id="plan-recommendation-plan-card-headline">
      {{t this.card.headline.key planName=(t this.card.headline.params.planName)}}
    </h1>
  
    <p class="cPR--planCard__description" data-test-id="plan-recommendation-plan-card-description">
      {{this.description}}
    </p>
  
    <h2 class="cPR--planCard__offersLabel" data-test-id="plan-recommendation-plan-card-offers-label">
      {{t this.card.offersLabel.key planName=(t this.card.offersLabel.params.planName)}}
    </h2>
  
    <ul class="cPR--planCard__callouts">
      {{#each this.card.callouts as |callout|}}
        <li
          class="cPR--planCard__callout"
          data-test-id="plan-recommendation-plan-card-callout"
          data-test-tag={{callout.tag}}
        >
          {{! Decorative: the tag and copy beside it already carry the meaning. }}
          {{svg-jar (get this.calloutIcon callout.tag) aria-hidden="true" class="cPR--planCard__calloutIcon"}}
          <span class="cPR--planCard__calloutText">
            <span class="cPR--planCard__calloutTag">{{t callout.tagKey}}</span>
            <span class="cPR--planCard__calloutCopy">{{t callout.copyKey}}</span>
          </span>
        </li>
      {{/each}}
    </ul>
  
    <p class="cPR--planCard__footnote" data-test-id="plan-recommendation-plan-card-footnote">
      {{t this.card.footnoteKey}}
    </p>
  
    {{#if this.card.alternative}}
      <p class="cPR--planCard__alternative" data-test-id="plan-recommendation-plan-card-alternative">
        <span class="cPR--planCard__alternativePrompt">
          {{t this.card.alternative.prompt.key planName=(t this.card.alternative.prompt.params.planName)}}
        </span>
        <span class="cPR--planCard__alternativeCondition">{{t this.card.alternative.conditionKey}}</span>
      </p>
    {{/if}}
  
    {{! The button drops repeat clicks and disables itself while @promise runs. }}
    <Shared::Ui::Button
      @additional="block"
      @promise={{this.openCheckout}}
      @text={{t this.card.cta.key planName=(t this.card.cta.params.planName)}}
      @variant="primary"
      data-test-id="plan-recommendation-plan-card-cta"
    />
  </div>
  */
  {
    "id": "05aiy3KP",
    "block": "[[[11,0],[24,0,\"cPR--planCard\"],[24,\"data-test-id\",\"plan-recommendation-plan-card\"],[16,\"data-test-tier\",[30,1,[\"tier\"]]],[17,2],[12],[1,\"\\n  \"],[10,\"h1\"],[14,0,\"cPR--planCard__headline\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-headline\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[[30,0,[\"card\",\"headline\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"headline\",\"params\",\"planName\"]]],null]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,2],[14,0,\"cPR--planCard__description\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-description\"],[12],[1,\"\\n    \"],[1,[30,0,[\"description\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"h2\"],[14,0,\"cPR--planCard__offersLabel\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-offers-label\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[[30,0,[\"card\",\"offersLabel\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"offersLabel\",\"params\",\"planName\"]]],null]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"ul\"],[14,0,\"cPR--planCard__callouts\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"card\",\"callouts\"]]],null]],null],null,[[[1,\"      \"],[10,\"li\"],[14,0,\"cPR--planCard__callout\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-callout\"],[15,\"data-test-tag\",[30,3,[\"tag\"]]],[12],[1,\"\\n\"],[1,\"        \"],[1,[28,[35,3],[[28,[37,4],[[30,0,[\"calloutIcon\"]],[30,3,[\"tag\"]]],null]],[[\"aria-hidden\",\"class\"],[\"true\",\"cPR--planCard__calloutIcon\"]]]],[1,\"\\n        \"],[10,1],[14,0,\"cPR--planCard__calloutText\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"cPR--planCard__calloutTag\"],[12],[1,[28,[35,0],[[30,3,[\"tagKey\"]]],null]],[13],[1,\"\\n          \"],[10,1],[14,0,\"cPR--planCard__calloutCopy\"],[12],[1,[28,[35,0],[[30,3,[\"copyKey\"]]],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[3]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,2],[14,0,\"cPR--planCard__footnote\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-footnote\"],[12],[1,\"\\n    \"],[1,[28,[35,0],[[30,0,[\"card\",\"footnoteKey\"]]],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"card\",\"alternative\"]],[[[1,\"    \"],[10,2],[14,0,\"cPR--planCard__alternative\"],[14,\"data-test-id\",\"plan-recommendation-plan-card-alternative\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"cPR--planCard__alternativePrompt\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[[30,0,[\"card\",\"alternative\",\"prompt\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"alternative\",\"prompt\",\"params\",\"planName\"]]],null]]]]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"cPR--planCard__alternativeCondition\"],[12],[1,[28,[35,0],[[30,0,[\"card\",\"alternative\",\"conditionKey\"]]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"  \"],[8,[39,6],[[24,\"data-test-id\",\"plan-recommendation-plan-card-cta\"]],[[\"@additional\",\"@promise\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"openCheckout\"]],[28,[37,0],[[30,0,[\"card\",\"cta\",\"key\"]]],[[\"planName\"],[[28,[37,0],[[30,0,[\"card\",\"cta\",\"params\",\"planName\"]]],null]]]],\"primary\"]],null],[1,\"\\n\"],[13]],[\"@recommendation\",\"&attrs\",\"callout\"],false,[\"t\",\"each\",\"-track-array\",\"svg-jar\",\"get\",\"if\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/plan-recommendation/plan-card.hbs",
    "isStrictMode": false
  });
  /**
   * Callout tag -> `svg-jar` asset name.
   *
   * The design frame names icons for only the three tags that one card happens to show, so the
   * other four take the nearest existing asset in `public/assets/icons`.
   *
   * `analyze` and `benchmark` must never resolve to the same asset: five of the six Scale rows in
   * `CALLOUT_ORDER` put both on one card, and a repeated glyph reads as a bug.
   */
  const CALLOUT_ICON = {
    plan: 'planner',
    publish: 'send',
    approve: 'approved',
    engage: 'social-inbox',
    analyze: 'insights',
    benchmark: 'custom-analytics',
    monitor: 'social-listening'
  };
  let PlanCardComponent = _exports.default = (_class = class PlanCardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor2, this);
      /**
       * A field initializer runs once per instance, matching how the terminal slide scores: a getter
       * would re-assemble the whole card on every re-render.
       */
      _defineProperty(this, "card", (0, _planCard.buildPlanCard)(this.args.recommendation.tier, this.args.answers));
      /** Exposed for the template's `{{get}}` lookup; the callouts themselves stay the module's own. */
      _defineProperty(this, "calloutIcon", CALLOUT_ICON);
      /**
       * `drop` because `openCheckoutModal` reloads the subscription and the account before the modal
       * appears, and a second click during that gap would run the whole sequence again. The button
       * disables itself for as long as this is running, which is why the service has to return its
       * promise rather than fire the reloads and forget them.
       *
       * The default action only. Answer-specific destinations and checkout attribution are ticket 08.
       */
      _defineProperty(this, "openCheckout", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.seamlessCheckoutManager.openCheckoutModal(this.args.recommendation.planType);
        }
      }), {
        drop: true
      }, "openCheckout", null));
    }
    /**
     * The one field the template cannot resolve itself. Its params are absent for every question the
     * user skipped, and a subexpression like `(if params.q1Phrase (t params.q1Phrase))` does not
     * help — Handlebars evaluates both branches, so the absent ones still reach `t` as undefined.
     *
     * Resolving here keeps the alternative — eight `{{#if}}` arms, one per answered set — out of the
     * template. The copy still comes wholly from the copy module; this only looks up its keys.
     */
    get description() {
      const {
        key,
        params
      } = this.card.description;
      const resolved = {};
      if (params.q1Phrase !== undefined) {
        resolved.q1Phrase = this.intl.t(params.q1Phrase);
      }
      if (params.q2Range !== undefined) {
        resolved.q2Range = this.intl.t(params.q2Range);
      }
      if (params.q3Goal !== undefined) {
        resolved.q3Goal = this.intl.t(params.q3Goal);
      }
      if (params.valueSentence !== undefined) {
        resolved.valueSentence = this.intl.t(params.valueSentence.key, {
          planName: this.intl.t(params.valueSentence.params.planName)
        });
      }
      return (0, _template.htmlSafe)(this.intl.t(key, resolved));
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PlanCardComponent);
});